<template>
  <!-- partial:partials/_footer.html -->
  <footer class="footer">
    <div class="d-sm-flex justify-content-center justify-content-sm-between">
      <span
        class="text-muted text-center text-sm-left d-block d-sm-inline-block"
        >Copyright © 2021. Premium
        <a href="https://www.bootstrapdash.com/" target="_blank"
          >Bootstrap admin template</a
        >
        from BootstrapDash. All rights reserved.</span
      >
    </div>
    <div
      class="d-sm-flex justify-content-center justify-content-sm-between"
    ></div>
  </footer>
</template>

<script>
export default {
  name: "PageFooter",
};
</script>

<style></style>
